import * as React from 'react';
import classNames from 'classnames';
import omit from 'omit.js';
const Icon = (props) => {
    const { type, className = '', spin } = props;
    const classString = classNames({
        icon: true,
        'icon_spin': !!spin || type === 'loading',
        [`icon_${type}`]: true,
    }, className);
    return <i {...omit(props, ['type', 'spin'])} className={classString}/>;
};
export default Icon;



// WEBPACK FOOTER //
// ./components/icon/index.tsx